import { call, take, put, cancel, cancelled, select, takeLeading, actionChannel, flush } from 'redux-saga/effects';
import { buffers } from 'redux-saga';
import ky from 'ky-universal';
import { stringify } from 'query-string';
import { normalize, schema } from 'normalizr';

import { apiHost } from '../../config/api';
import baseFields from '../../config/api/baseFields';
import { AUTH_STATE_LOGIN, REQUEST_STATE_SUCCEEDED } from '../../constants';
import authUtils from '../utils/auth';

import {
  AUTH_FLOW_END,
  LOGOUT,
  FETCH_PRODUCT_SUBSCRIPTIONS,
  FETCH_PRODUCT_SUBSCRIPTIONS_REQUESTING,
  FETCH_PRODUCT_SUBSCRIPTIONS_ABORTED,
  FETCH_PRODUCT_SUBSCRIPTIONS_FAILED,
  FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED,
} from '../constants/actionTypes';

function* fetchProductSubscriptions() {
  const productSubscriptionsFetchState = yield select((state) => state.user.productSubscriptionsFetchState);

  if (productSubscriptionsFetchState === REQUEST_STATE_SUCCEEDED) return;

  const abortController = new AbortController();

  try {
    yield put({ type: FETCH_PRODUCT_SUBSCRIPTIONS_REQUESTING })

    const res = yield call(ky.get, `${apiHost}/purchase/v2/order/subscription`, {
      signal: abortController.signal,
      headers: {
        Authorization: authUtils.getAccessToken(),
      },
      searchParams: stringify(baseFields),

      /** 無訂閱會回 404, 但不應該當錯誤處理 */
      throwHttpErrors: false,
    });

    const { order, ownerships, unfulfilleds } = yield res.json();

    const packageSubscriptionEntity = new schema.Entity('packageSubscription', {
      srcInfo: {
        deal: new schema.Entity('deal'),
      },
      item: {
        package: new schema.Entity('subscribedPackages'),
      },
    });

    yield put({ 
      type: FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED, 
      payload: {
        'vip': order,
        'package': normalize(ownerships, [packageSubscriptionEntity]),
        'unfulfilleds': unfulfilleds,
      }})
  } catch (error) {
    yield put({ type: FETCH_PRODUCT_SUBSCRIPTIONS_FAILED, payload: error, error: true })
  } finally {
    if (yield cancelled()) {
      abortController.abort();
      yield put({ type: FETCH_PRODUCT_SUBSCRIPTIONS_ABORTED })
    }
  }
}

export function* fetchProductSubscriptionsFlow() {
  const queue = yield actionChannel(FETCH_PRODUCT_SUBSCRIPTIONS, buffers.dropping(1));

  while (true) {
    const { payload } = yield take(AUTH_FLOW_END);

    if (payload === AUTH_STATE_LOGIN) {
      const task = yield takeLeading(queue, fetchProductSubscriptions);
      yield take(LOGOUT);
      yield cancel(task);
    }

    yield flush(queue);
  }
}
